// extracted by mini-css-extract-plugin
module.exports = {"root":"FormLabel-module--root--cbqbS","info":"FormLabel-module--info--3Xzzw"};